import { ArrowClockwise, CheckCircle, Clock, Eye, Trash } from 'phosphor-react'
import { useEffect, useState } from 'react'
import {
  Col,
  Container,
  Form,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from 'react-bootstrap'
import { Search } from 'react-bootstrap-icons'
import { toast } from 'react-toastify'
import { Ask } from '../../../components/Ask'
import { Center } from '../../../components/Center'
import { CustomButton } from '../../../components/CustomButton'
import { CustomSpinner } from '../../../components/CustomSpinner'
import Navbar from '../../../components/navbar/navbar'
import { useOrdenation } from '../../../hooks/useOrdenation'
import WmsBonusService from '../../../services/database/WmsBonusService'
import WmsConfBonusService from '../../../services/database/WmsConfBonusService'
import { formatDate } from '../../../utils/formatDate'
import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'
import { ModalItems } from './ModalItems'

export function WMSBonus() {
  const [bonus, setBonus] = useState([])
  const [isBonusLoading, setIsBonusLoading] = useState(true)

  const [items, setItems] = useState([])
  const [isItemsBonusLoading, setIsItemsBonusLoading] = useState({})
  const [isModalItemsOpen, setIsModalItemsOpen] = useState(false)

  const [isDeleteBonusLoading, setIsDeleteBonusLoading] = useState(false)

  const [search, setSearch] = useState({
    num_bonus: '',
    num_trans: '',
    numped: '',
    fornecedor: '',
    databonus: '',
  })
  const [isLoadingSearch, setIsLoadingSearch] = useState(false)

  const { filteredItems, Th, Paginate } = useOrdenation(bonus, 'num_bonus')

  function handleChangeSearch(e) {
    const { name, value } = e.target

    setSearch((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  function handleKeyPress(e) {
    if (e.key === 'Enter') {
      handleSearch()
    }
  }

  async function handleSearch() {
    try {
      setIsLoadingSearch(true)

      const data = await WmsBonusService.search(search)

      console.log({ data })

      setBonus(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível concluir a busca')
    } finally {
      setIsLoadingSearch(false)
    }
  }

  async function loadBonus() {
    try {
      setIsBonusLoading(true)

      const data = await WmsConfBonusService.getAll()

      setBonus(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível carregar os bônus!')
    } finally {
      setIsBonusLoading(false)
    }
  }

  async function getAllItems(bonusId, index) {
    try {
      setIsItemsBonusLoading((prevState) => ({ ...prevState, [index]: true }))

      const data = await WmsConfBonusService.getAllItems(bonusId)

      setItems(data)
      setIsModalItemsOpen(true)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível listar os itens do bônus!')
    } finally {
      setIsItemsBonusLoading((prevState) => ({ ...prevState, [index]: false }))
    }
  }

  async function handleDeleteBonus(bonusId) {
    try {
      setIsDeleteBonusLoading(true)

      await WmsBonusService.delete(bonusId)

      toast.success('Bônus excluído com sucesso!')
      loadBonus()
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível excluir o bônus!')
    } finally {
      setIsDeleteBonusLoading(false)
    }
  }

  useEffect(() => {
    loadBonus()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <Container className="d-flex flex-column align-items-center justify-content-center">
          <h1>Entrada de Produtos (Bônus)</h1>

          <p>
            Para gerar um bônus, escolha um <strong>Pedido de Compra</strong> e
            clique em <strong>Criar Bônus de Entrada</strong>.
          </p>
        </Container>

        <Row>
          <Col>
            <Form.Label>Bônus</Form.Label>
            <Form.Control
              name="num_bonus"
              value={search.num_bonus}
              onChange={handleChangeSearch}
              onKeyDown={handleKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>Transação</Form.Label>
            <Form.Control
              name="num_trans"
              value={search.num_trans}
              onChange={handleChangeSearch}
              onKeyDown={handleKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>Pedido</Form.Label>
            <Form.Control
              name="numped"
              value={search.numped}
              onChange={handleChangeSearch}
              onKeyDown={handleKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>Fornecedor</Form.Label>
            <Form.Control
              name="fornecedor"
              value={search.fornecedor}
              onChange={handleChangeSearch}
              onKeyDown={handleKeyPress}
            />
          </Col>

          <Col>
            <Form.Label>Data</Form.Label>
            <Form.Control
              type="date"
              name="databonus"
              value={search.databonus}
              onChange={handleChangeSearch}
              onKeyDown={handleKeyPress}
            />
          </Col>

          <Col>
            <div
              style={{
                minHeight: '100%',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-start',
              }}
            >
              <CustomButton
                title="Pesquisar"
                onClick={handleSearch}
                isLoading={isLoadingSearch}
                isLoadingText="Pesquisando..."
              >
                <Search />
              </CustomButton>
            </div>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <CustomButton
              noMargin
              isLoading={isBonusLoading}
              isLoadingText="Atualizando..."
              onClick={loadBonus}
              title="Atualizar"
            >
              <ArrowClockwise weight="fill" />
            </CustomButton>
          </Col>
        </Row>

        {isBonusLoading ? (
          <Center>
            <CustomSpinner size={26} />
          </Center>
        ) : (
          <>
            {bonus.length > 0 ? (
              <>
                <Table
                  hover
                  striped
                  bordered
                  responsive
                >
                  <thead>
                    <tr>
                      <Th
                        label="Bônus"
                        value="num_bonus"
                      />

                      <Th
                        label="Transação"
                        value="num_trans"
                      />

                      <Th
                        label="Pedido"
                        value="numped"
                      />

                      <Th
                        label="Fornecedor"
                        value="fornecedor"
                      />

                      <Th
                        label="Data"
                        value="databonus"
                      />

                      <Th
                        label="Qtd Itens"
                        value="quantidade_itens"
                      />

                      <Th label="Status" />

                      <Th label="Ações" />
                    </tr>
                  </thead>

                  <tbody>
                    {filteredItems.map((b, i) => (
                      <tr key={b.num_bonus}>
                        <td>{b.num_bonus}</td>
                        <td>{b.num_trans}</td>
                        <td>{b.numped}</td>
                        <td>{b.fornecedor}</td>
                        <td>{formatDate(b.databonus)}</td>
                        <td>{b.quantidade_itens}</td>
                        <td>
                          <OverlayTrigger
                            overlay={
                              <Tooltip>
                                {b.status === 'F'
                                  ? 'Finalizado'
                                  : 'Em Andamento'}
                              </Tooltip>
                            }
                          >
                            {b.status === 'F' ? (
                              <CheckCircle
                                weight="fill"
                                color="green"
                                size={25}
                              />
                            ) : (
                              <Clock
                                weight="fill"
                                color="orange"
                                size={25}
                              />
                            )}
                          </OverlayTrigger>
                        </td>
                        <td>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <OverlayTrigger
                              overlay={<Tooltip>Mostrar Produtos</Tooltip>}
                            >
                              <CustomButton
                                isLoading={isItemsBonusLoading[i]}
                                onClick={() => getAllItems(b.num_bonus, i)}
                              >
                                <Eye weight="fill" />
                              </CustomButton>
                            </OverlayTrigger>

                            <OverlayTrigger
                              overlay={<Tooltip>Excluir</Tooltip>}
                            >
                              <CustomButton
                                isLoading={isDeleteBonusLoading}
                                isLoadingText="Excluindo..."
                                isDelete
                                onClick={() =>
                                  Ask(
                                    'Tem certeza que deseja excluir? Essa ação é irreversível!',
                                    () => handleDeleteBonus(b.num_bonus),
                                  )
                                }
                              >
                                <Trash weight="fill" />
                              </CustomButton>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Paginate />
              </>
            ) : (
              <Center>
                <p>Nenhum bônus encontrado.</p>
              </Center>
            )}
          </>
        )}
      </div>

      {isModalItemsOpen && (
        <ModalItems
          isOpen={isModalItemsOpen}
          onClose={() => setIsModalItemsOpen(false)}
          getAllItems={getAllItems}
          items={items}
        />
      )}
    </>
  )
}
